import React from 'react'
import { Box, Typography, Paper, useTheme } from '@mui/material'
import { TIER_PRICING } from '@/utils/billingConstants'

interface TierSelectorProps {
  selectedTier: number | null
  onTierSelect: (tier: number) => void
}

// Display order: largest to smallest
const TIER_ORDER = [1, 2, 3, 4, 0]

export default function TierSelector({
  selectedTier,
  onTierSelect,
}: TierSelectorProps) {
  const theme = useTheme()

  return (
    <Box sx={{ width: '100%', maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom sx={{ mb: 1, fontWeight: 600 }}>
        Select Your Organisation's Tier
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Your tier is based on your annual turnover. Please select the tier that
        matches your organisation.
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {TIER_ORDER.map((tierNum) => {
          const pricing = TIER_PRICING[tierNum]
          const isSelected = selectedTier === tierNum

          return (
            <Paper
              key={tierNum}
              elevation={isSelected ? 2 : 0}
              sx={{
                p: 2.5,
                border: isSelected
                  ? `2px solid ${theme.palette.primary.main}`
                  : '1px solid #e0e0e0',
                borderRadius: 2,
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                },
              }}
              onClick={() => onTierSelect(tierNum)}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    {pricing.description}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Annual turnover: {pricing.turnover}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          )
        })}
      </Box>
    </Box>
  )
}
